import type { EditorCommand } from '@atlaskit/editor-common/types';

import { malleableUiPluginKey } from '../pm-plugins/plugin-key';

export const closeRemixModal =
	(): EditorCommand =>
	({ tr }) => {
		tr.setMeta(malleableUiPluginKey, { isRemixModalOpen: false });
		return tr;
	};
